<template>
  <v-layout row wrap style="min-height: 86vh">
    <div class="home">
      <img src="~@/assets/images/dashboard-bg.jpg" alt="">
    </div>
    <v-flex sm12 md6 :pr-1="$vuetify.breakpoint.mdAndUp" :pb-1="$vuetify.breakpoint.smAndDown">
      <v-card class="fill-height">
        <v-radio-group
          v-model="radios"
          :mandatory="false"
          row
          class="px-4 pt-4">
          <v-radio
            color="primary"
            label="Unread"
            value="unread"/>
          <v-radio
            color="primary"
            label="Read"
            value="read"/>
        </v-radio-group>
        <v-data-table
          :headers="headers"
          :items="announcements"
          :loading="loading"
          :pagination.sync="pagination"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <tr :style="`cursor: pointer; ${subjectData.id === props.item.id ? 'background-color: #E0E0E0' : ''}`" @click="showDetails(props.item)">
            <td :style="subjectData.id === props.item.id ? 'font-weight: 900 !important' : ''">{{ props.item.subject }}</td>
            <td :style="subjectData.id === props.item.id ? 'font-weight: 900 !important' : ''">{{ formatDate(props.item.createdOn) }}</td>
            <td style="width: 180px;">
              <v-btn
                class="primary elevation-1 mx-0"
                @click="showDetails(props.item)">
                show
              </v-btn>
            </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
    <v-flex sm12 md6 :pl-1="$vuetify.breakpoint.mdAndUp" :pt-1="$vuetify.breakpoint.smAndDown" v-if="announcements && announcements.length > 0">
      <v-card class="py-3 px-4 fill-height">
        <v-layout row wrap justify-space-between align-center style="border-bottom: 1px solid #E0E0E0">
          <h2>{{subjectData.subject || ''}}</h2>
          <div>
            <span class="pr-2"><small>{{ formatDate(subjectData.createdOn) }}</small></span>
            <v-btn
              :disabled="subjectData.isRead"
              class="elevation-0 mx-0"
              small
              color="primary"
              @click="markAsRead()">
              Mark as read
            </v-btn>
          </div>
        </v-layout>
        <div class="pt-4" v-html="subjectData.message" />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      subject: () => import('../components/modals/ShowSubject'),
    },
    data() {
      return {
        err: '',
        radios: 'unread',
        headers: [
          {text: 'subject', value: 'message', align: 'left',},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left', sortable: true,},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false,},
        ],
        loading: false,
        announcements: [],
        subjectData: {},
        showSubject: false,
        pagination: {
          sortBy: 'createdOn',
          descending: true,
        },
      };
    },
    watch: {
      radios: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.getData(newVal);
          }
        },
      },
    },
    created() {
      this.getData('unread');
    },
    methods: {
      markAsRead() {
        this.$http.post(`announcement/markasread/${this.subjectData.id}`, {})
          .then((res) => {
            if (res.body.status === 'Success') {
              this.subjectData.isRead = true;
              this.getData(this.radios);
            }
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      updateData() {
        this.showSubject = false;
        this.getData(this.radios);
      },
      showDetails(data) {
        this.subjectData = data;
        this.showSubject = true;
      },
      getData(type) {
        this.loading = true;
        this.$http.post('announcement/getall', { filter: type })
        .then((res) => {
          if (res.body.status === 'Success') {
            this.announcements = res.body.announcements;
            this.subjectData = res.body.announcements[0];
            this.loading = false;
            return;
          }
          this.loading = false;
          this.err = res.body.statusText;
        }, (err) => {
          this.loading = false;
          this.err = err.body.statusText || err.body.message;
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .home {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      position: absolute;
      width: auto;
      height: auto;
      min-height: 100%;
      min-width: 100%;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?0025911a